export const constructStrRep = (obj) => {
  return obj.str_representation || obj.title || "Kostnadsställe";
};

export const detailUrl = ({ id }) => {
  return `/rental-notifications/invoicing-objects/cost-centers/${id}`;
};
